// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { useEffect, useRef } from 'react';

import { preloadSceneImages } from '../../store/utils/imageCache';

export const usePreloadScenes = (scenes, delay = 0) => {
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (!scenes?.length) {
      return;
    }
    // Abort any previous in-progress preload
    abortControllerRef.current?.abort();

    // Create a fresh controller for the new preload cycle
    const controller = new AbortController();
    abortControllerRef.current = controller;

    // Delay preload to avoid flooding the network
    const timeoutId = setTimeout(() => {
      preloadSceneImages(scenes, controller.signal);
    }, delay);

    // Cleanup on unmount or when scenes change
    return () => {
      clearTimeout(timeoutId);
      abortControllerRef.current?.abort();
    };
  }, [scenes, delay]);
};
